// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as InfoComponent} from './Info.svg';

import Icon, { TIconProps } from '../Icon';

export const IconInfo = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <InfoComponent/>
  </Icon>
));
